module.exports = __webpack_public_path__ + "img/sky-down.f24febf2.png";